export const translations = {
  routeCreateSuccessMessage: {
    pt: 'Rota criada com sucesso',
    en: 'Route created successfully',
    es: 'Ruta creada con éxito',
    de: 'Route erfolgreich erstellt',
  },
  routeCreateErrorMessage: {
    pt: 'Erro ao criar rota',
    en: 'Error creating route',
    es: 'Error al crear la ruta',
    de: 'Fehler beim Erstellen der Route',
  },
}